export const DEBUG = process.env.NODE_ENV === 'development'
export const DISABLE_ANALYTICS = process.env.REACT_APP_DISABLE_ANALYTICS ? true : false

export const FAMILY_ALBUM_URL = process.env.REACT_APP_FAMILY_ALBUM_URL ? process.env.REACT_APP_FAMILY_ALBUM_URL : ''

export const PICTURE_DEBUG = process.env.REACT_APP_DEBUG_PICTURE ? process.env.REACT_APP_DEBUG_PICTURE : ''

export const SERVER_URL = process.env.REACT_APP_SERVER_URL ? process.env.REACT_APP_SERVER_URL : ''

export const WEAVER_URL = process.env.REACT_APP_WEAVER_URL ? process.env.REACT_APP_WEAVER_URL : ''

export const THEME_COLOR = process.env.REACT_APP_THEME_COLOR ? process.env.REACT_APP_THEME_COLOR : 'red'
export const TITLE = process.env.REACT_APP_TITLE ? process.env.REACT_APP_TITLE : 'Carpet'

export const DEFAULT_MOMENT_FORMAT = 'DD.MM.YYYY'
export const DEFAULT_MOMENT_FORMAT_WITH_TIME = 'DD.MM.YYYY, HH:mm:ss'

export const DESIGNER_QUEUE_START_DATE = DEBUG ? '2017-04-01' : '2018-08-06'

export const ISO_DATE_FORMAT = 'YYYY-MM-DD'

export const PICTURE_TYPES = {
  C3_BIG: 'jpg_c3_big',
  C3_THUMBNAIL: 'jpg_c3_thumbnail',
  ORIGINAL_CROPPED: 'jpg_original_cropped',
  ORIGINAL_JPG: 'jpg_original',
  ORIGINAL_RAW: 'raw_original',
  TIF_DESIGNER: 'tif_designer',
}

export const SETTINGS_KEYS = {
  ADDITIONAL_ADVISORS: 'additionalAdvisors',
  IGNORE_DP_NOTIFICATIONS: 'ignoreDesignerPictureRequests',
  LAYOUT: 'layout',
  SORT_BY: 'sortBy',
  SORT_ORDER: 'sortOrder',
}
